import { connect } from 'react-redux';

import RatingsUsersFilter from './RatingsUsersFilter';
import { selectUsersFilterKey } from '../Ratings.selectors';
import { updateUserFilter } from '../Ratings.saga';

const mapStateToProps = state => ({ selectedUsersFilterKey: selectUsersFilterKey(state) });

const mapDispatchToProps = { updateUserFilter };

export default connect(mapStateToProps, mapDispatchToProps)(RatingsUsersFilter);
